/**
 * Titel und Hinweise der Werkzeuge, wie Claude sie dem Nutzer zeigt.
 *
 * EIGENE DATEI OHNE ABHAENGIGKEITEN, weil zwei Seiten sie lesen: der MCP
 * (tools.ts, tools/list) und die Anleitung in apps/web. Zwei Listen wuerden
 * auseinanderlaufen, und die Anleitung zeigte dann Namen, die in Claude nie
 * erscheinen. Begruendung der Felder in tools.ts bei listToolDefs.
 */

export type Anzeige = { title: string; readOnly: boolean; destructive?: boolean; openWorld?: boolean };

export const ANZEIGE = {
  get_started: { title: 'Loslegen: was hast du vor?', readOnly: true },
  list_persona_sets: { title: 'Zielgruppen anzeigen', readOnly: true },
  plan_simulation: { title: 'Run planen und Preis nennen', readOnly: true },
  preselect_copy: { title: 'Entwürfe vorsortieren (Credits)', readOnly: false },
  simulate_copy: { title: 'Text gegen Personas prüfen (Credits)', readOnly: false },
  publish_report: { title: 'Bericht veröffentlichen', readOnly: false },
  set_leitplanken: { title: 'Leitplanken des Kunden festlegen', readOnly: false },
  start_research: { title: 'Persona-Recherche starten', readOnly: true },
  read_competitors: { title: 'Wettbewerberseiten lesen', readOnly: true, openWorld: true },
  find_voices: { title: 'Kundenstimmen suchen', readOnly: true, openWorld: true },
  import_conversations: { title: 'Eigene Gespräche als Belege einlesen (Credits)', readOnly: false },
  delete_conversations: { title: 'Eigene Gespräche anzeigen oder löschen', readOnly: false, destructive: true },
  save_persona_set: { title: 'Zielgruppe speichern (Credits)', readOnly: false },
  revise_persona_set: { title: 'Zielgruppe ändern', readOnly: false, destructive: true },
  run_study: { title: 'Landingpages prüfen und vergleichen (Credits)', readOnly: false, openWorld: true },
  compare_claims: { title: 'Kernaussagen gegen Wettbewerb prüfen (Credits)', readOnly: false, openWorld: true },
  write_challenger: { title: 'Challenger-Fassungen schreiben (Credits)', readOnly: false },
  draft_funnel: { title: 'Funnel nach Vorlage entwerfen (Credits)', readOnly: false },
  test_page: { title: 'Seite als A/B-Test prüfen (Credits)', readOnly: false, openWorld: true },
  check_design: { title: 'Wirkung der Gestaltung prüfen (Credits)', readOnly: false, openWorld: true },
  check_structure: { title: 'Seitenaufbau und Lesefluss prüfen (Credits)', readOnly: false, openWorld: true },
  analyze_page: { title: 'Landingpage komplett analysieren (Credits)', readOnly: false, openWorld: true },
  test_first_screen: { title: 'Above the Fold im Vergleich (Credits)', readOnly: false, openWorld: true },
  get_job: { title: 'Ergebnis eines Tests abholen', readOnly: true },
  start_build: { title: 'Ausbau anlegen, fortsetzen oder Schritt entscheiden', readOnly: false },
  test_variants: { title: 'Varianten eines Abschnitts testen (Credits)', readOnly: false },
  finish_build: { title: 'Ausbau abschließen (Credits)', readOnly: false },
  report_outcome: { title: 'Marktergebnis melden oder Trefferquote zeigen', readOnly: false },
  get_balance: { title: 'Guthaben anzeigen', readOnly: true },
  find_funnels: { title: 'Funnel-Bibliothek und Hero-Vorlagen', readOnly: true },
} satisfies Record<string, Anzeige>;

